import React, { useEffect, useState } from "react";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Contributor from "../../atoms/Contributor";
import PublishedAt from "../../atoms/PublishedAt";

import { getAuthorName } from "../../utils/utils";
import { getAuthorObj } from "../../helper/api";

import "./storyMetaData.m.css";

const StoryMetaData = ({ story, isAuthor, isTag, isPublished, updatedFont, publisherLang, src }) => {
  const tagObj = isTag ? get(story, ["tags", "0"], null) : null; // If tag required then try to fetch
  const authorName = getAuthorName(story);
  const tagStyleNameDefault = updatedFont ? `${publisherLang}-tag tag-name` : "tag-name";
  const timeStyleNameDefault = updatedFont ? `${publisherLang}-time tag-name` : "tag-name";
  const tagStyleNameWithSrc = updatedFont && src && `${publisherLang}-tag-${src} tag-name`;
  const timeStyleNameWithSrc = updatedFont && src && `${publisherLang}-time-${src} tag-name`;
  const tagStyle = src ? tagStyleNameWithSrc : tagStyleNameDefault;
  const timeStyle = src ? timeStyleNameWithSrc : timeStyleNameDefault;

  const [authorObj, setAuthorObj] = useState({});

  const firstAuthor = isAuthor && get(story, ["authors", "0"], null); // If author required then try to fetch

  const fetchAuthorObj = async authorId => {
    if (authorId) {
      const data = await getAuthorObj(authorId);
      setAuthorObj(data);
    }
  };

  useEffect(() => {
    if (isAuthor) {
      fetchAuthorObj(firstAuthor.id);
    }
  }, []);

  return (
    <div styleName="story-meta-data" className="story-meta-data" data-testid="tag-related">
      {isAuthor && authorObj && (
        <Contributor
          name={authorName}
          contributorType={5}
          slug={`/author/${authorObj.slug}`}
          className="contributor"
          authorObj={authorObj}
        />
      )}
      {tagObj && (
        <Link href={`/topic/${tagObj.slug}`} styleName={tagStyle} className="tag-name">
          {tagObj.name}
        </Link>
      )}
      {isPublished && (
        <PublishedAt date={story["last-published-at"]} className="published-time" styleName={timeStyle} />
      )}
    </div>
  );
};

StoryMetaData.defaultProps = {
  isAuthor: false,
  isTag: true,
  isPublished: true
};

StoryMetaData.propTypes = {
  story: object.isRequired,
  isTag: bool,
  isAuthor: bool,
  isPublished: bool,
  updatedFont: bool,
  publisherLang: string,
  src: string
};

export default StoryMetaData;
